import { mapGetters, mapMutations } from 'vuex';
import { getterTypes } from '@/store/getter-types';
import { mutationTypes } from '@/store/mutation-types';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Langs_List, getterTypes.Getter_Lang]),
  },
  methods: {
    ...mapMutations([mutationTypes.SET_LANG]),
    // 切换语言
    changeLang(lang) {
      console.log('lang', lang);
      this.SET_LANG(lang);
      window.location.reload(true);
      /* let timer = setTimeout(() => {
        clearTimeout(timer);
        window.location.reload(true);
      }, 25); */
    },
  },
};
